import React, { useRef, useState, useMemo, useEffect } from "react";
import { RCCAlert, RCCButton, RCCGrid, RCCHookToast, RCCInput, RCCSelectOptionsCard, RCCServicesApi, RCCSwitch, RCCTooltip } from "react-common-components";
import { IRefPrintContainer } from "react-common-components/dist/components/PrintContainer/interface";
import { IRefComponentSelectOptionsCard } from "react-common-components/dist/components/SelectOptionsCard/interface";
import { useForm } from "react-hook-form";
import FadedDiv from "src/components/Animations/fade";
import ButtonExpandGroupers from "src/components/ButtonExpandGroupers";
import ConfigsContainer from "src/components/ConfigsContainer";
import DateTimePicker from "src/components/DateTimePicker";
import DateTimePickerRange from "src/components/DateTimePickerRange";
import FiltersContainer from "src/components/FiltersContainer";
import FiltersTagsContainer from "src/components/FiltersTagsContainer";
import { IRefFiltersTagsContainer, TagsTypes } from "src/components/FiltersTagsContainer/interface";
import Loader from "src/components/Loader";
import LovClassifications from "src/components/Lov/Classifications";
import LovSectors from "src/components/Lov/Sectors";
import LovUsers from "src/components/Lov/Users";
import PageTitle from "src/components/PageTitle";
import Select from "src/components/Select";
import Title from "src/components/Title";
import { useAuth } from "src/context/Auth/context";
import { useTranslation } from "src/context/Translations/context";
import useEffectSkipInitialRender from "src/hooks/useEffectSkipInitialRender";
import { IConfigsShowGoal } from "src/pages/Indicators/Panel/components/ModalIndicatorChart/interface";
import { standardErrorMessages } from "src/utils/errors";
import extractSingleValueFromArrayOfObject from "src/utils/extractSingleValueFromArrayOfObject";
import formatDate from "src/utils/formatDate";
import isValidDate from "src/utils/isValidDate";
import { IGroupersIndicators, IGroupersIndicatorsSelect, IndicatorsGroupers } from "../../../Panel/interface";
import { IFiltersIndicatorsPanel, IPresentationContentComponent } from "../../interface";
import GrouperOfIndicatorsPresentationPanel from "../GrouperOfIndicatorsPresentationPanel";
import { IConfigsChartPresentation } from "./interface";

const PresentationGroupContentComponent: React.FC<IPresentationContentComponent> = ({
	selectedPresentationGroup,
	grouperProp,
	refModalValuesOfPeriodIndicators
}) => {
	const {translate} = useTranslation();
	const { user } = useAuth();
	const { addToast } = RCCHookToast();
    
	const filtersTagsRef = useRef<IRefFiltersTagsContainer>(null);
	const [showTagsFilters, setShowTagsFilters] = useState(false);
	const [showFilters, setShowFilters] = useState(false);
	const [print, setPrint] = useState(false);
	const [myIndicators, setMyIndicators] = useState(false);
	const [filters, setFilters] = useState<IFiltersIndicatorsPanel>({ 
		f: "", 
		responsible: "",
		presentationGroup: selectedPresentationGroup?.id ? selectedPresentationGroup.id.toString() : "",
		sector: "",
		startDate: null,
		endDate: null,
		classification: "",
		tags: "",
		level: ""
	});
	const { handleSubmit : handleSubmitFilters, register : registerFilters, control: controlFilters, reset: resetFilters, setValue: setValueFilters } = useForm();
	const submitFilters = async (data: any) => {
		const dataForm = data;
		if(data.situation)
			dataForm.situation = extractSingleValueFromArrayOfObject("value", data.situation)?.toString();
		
		if(typeof data.presentationGroup === "object")
			dataForm.presentationGroup = data.presentationGroup.value;
		if(typeof data.responsible === "object")
			dataForm.responsible = data.responsible.value;
		if(typeof data.sector === "object")
			dataForm.sector = data.sector.value;
		if(typeof data.classification === "object")
			dataForm.classification = data.classification.value;

		if(myIndicators)
			dataForm.responsible = user.efa005Id.toString();

		setFilters(dataForm);
	};
	const submitFiltersTags = async () => {
		setFilters((prevState) => {
			const updateState = {...prevState};
			updateState.tags = filtersTagsRef.current?.response || "";
			return updateState;
		});
	};

	// Configs
	const [showConfigs, setShowConfigs] = useState(false);
	const [toggleConfigShowGoals, setToogleConfigShowGoals] = useState<boolean>(false);
	const showValuesRef = useRef<IRefComponentSelectOptionsCard>(null);
	const { handleSubmit : handleSubmitConfigs, register: registerConfigs } = useForm();
	const [configs, setConfigs] = useState<IConfigsChartPresentation>({ 
	} as IConfigsChartPresentation);
	const [configShowGoals, setConfigShowGoals] = useState<IConfigsShowGoal | undefined>(undefined);
	const resetConfigsFunction = () => {
		setConfigs({} as IConfigsChartPresentation);
		showValuesRef.current?.changeValue("1");
		setToogleConfigShowGoals(false);
		setConfigShowGoals({
			showGoalCommitmentInGraphic: undefined,
			showGoalCompetitivenessInGraphic: undefined,
			showGoalImprovementInGraphic: undefined
		});
	};
	const submitConfigs = async (data: any) => {
		setConfigs((prevState) => ({ showAll: showValuesRef.current?.value === "1" ? undefined : showValuesRef.current?.value === "3", refModalValuesOfPeriodIndicators: prevState.refModalValuesOfPeriodIndicators }));
		setConfigShowGoals(!toggleConfigShowGoals ? undefined : {
			showGoalCommitmentInGraphic: data.showGoalCommitmentInGraphic,
			showGoalCompetitivenessInGraphic: data.showGoalCompetitivenessInGraphic,
			showGoalImprovementInGraphic: data.showGoalImprovementInGraphic
		});
	};

	const buttonSubmitFormGroupersRef = useRef<HTMLButtonElement>(null);
	const { handleSubmit : handleSubmitGroupers, control: controlGroupers, setValue: setValueGroupers, unregister: unregisterGroupers } = useForm();
	const [optValueGroup, setOptValueGroup] = useState<{ value: IndicatorsGroupers, label: string} | undefined>(undefined);
	const [groupersSelect, setGroupersSelect] = useState<IGroupersIndicatorsSelect>({
		group: grouperProp || IndicatorsGroupers.PRESENTATION_GROUP,
		baseYear: new Date().getFullYear().toString()
	});
	const optionsGroupers = [
		{ value: IndicatorsGroupers.SECTOR, label: `${translate("Setor")}` },
		{ value: IndicatorsGroupers.SECTOR_RESPONSIBLE, label: `${translate("Setor")} -> ${translate("Responsável")}` },
		{ value: IndicatorsGroupers.MAP, label: `${translate("Mapa")}` },
		{ value: IndicatorsGroupers.MAP_PERSPECTIVE, label: `${translate("Mapa")} -> ${translate("Perspectiva")}` },
		{ value: IndicatorsGroupers.MAP_PERSPECTIVE_OBJECTIVE, label: `${translate("Mapa")} -> ${translate("Perspectiva")} -> ${translate("Objetivo")}` },
		{ value: IndicatorsGroupers.PRESENTATION_GROUP, label: `${translate("Grupo de apresentação")}` },
		{ value: IndicatorsGroupers.INDICATOR_CLASSIFICATION, label: `${translate("Classificação do indicador")}` },
		{ value: IndicatorsGroupers.BUDGET_PLAN, label: `${translate("Plano orçamentário")}` }
	];
	const submitGroupers = async (data: any) => {
		setOptValueGroup(undefined);
		let baseYearVar = data.baseYear;
		if(typeof data.baseYear !== "string")
			baseYearVar = !isValidDate(data.baseYear) ? new Date().getFullYear().toString() : data.baseYear.getFullYear().toString();
		setGroupersSelect({
			...data,
			baseYear: baseYearVar
		});
	};

	useEffect(() => {
		submitGroupers({
			...groupersSelect,
			group: grouperProp
		});
		setValueGroupers("group", grouperProp.toString());
		setOptValueGroup(optionsGroupers.find((x) => x.value === grouperProp));
		unregisterGroupers("group");
	}, [grouperProp]);

	// Print
	const printRef = useRef<IRefPrintContainer>(null);
	const executePrint = () => {
		if(printRef.current){
			setPrint(true);
			printRef.current?.print();
			setPrint(false);
			return;
		}

		const groupers = document.querySelectorAll(".rccaccordion-groupers:not(.Mui-expanded)");
		const {length} = groupers;

		if(length === 0)
			return;

		for(let i = 0; i < 3; i += 1){
			if(groupers[i] === undefined)
				return;
			const accordionNode = groupers[i].firstChild as HTMLDivElement;
			setPrint(true);
			accordionNode.click();
		}
	};

	useEffect(() => {
		if(print){
			setTimeout(() => {
				printRef.current?.print();
				setPrint(false);
			}, 2000);
		}
	}, [print]);

	const loadGroupers = async () => {
		try{
			setLoading(true);
			setErrorLoadingGroupers(false);

			const {data} = await RCCServicesApi.getRequest({
				method: "Indicators/ListGroupers",
				urlParameters: {
					...groupersSelect,
					f: filters.f || "",
					responsible: filters.responsible || "",
					presentationGroup: selectedPresentationGroup?.id ? selectedPresentationGroup.id.toString() : "",
					sector: filters.sector || "",
					startDate: filters.startDate ? formatDate(filters.startDate) : "",
					endDate: filters.endDate ? formatDate(filters.endDate) : "",
					classification: filters.classification || "",
					tags: filters.tags || ""
				}
			});

			const groupersFromDB: IGroupersIndicators[] = data;	
			setGroupers(groupersFromDB); 

			setLoading(false);
		}catch(err){
			setErrorLoadingGroupers(true);
			standardErrorMessages(err, translate("Erro ao carregar os agrupadores"), addToast);
			setLoading(false);
		}
	};

	const [groupers, setGroupers] = useState<IGroupersIndicators[]>([]);
	const [loading, setLoading] = useState(true);
	const [errorLoadingGroupers, setErrorLoadingGroupers] = useState(false);

	const Groupers = useMemo(() => loading ? (
		<Loader />
	) : (
		<>
			{errorLoadingGroupers ? (
				<RCCAlert 
					title={translate("Atenção")}
					description={translate("Erro ao tentar encontrar resultados para esta pesquisa")}
				/>
			): (
				<>
					{groupers.length === 0 ? (
						<RCCAlert 
							title={translate("Atenção")}
							description={translate("Nenhum agrupador encontrado")}
						/>
					): (
						<>
							{groupers.map((grouper) => (
								<GrouperOfIndicatorsPresentationPanel 
									key={`${grouper.id}-${grouper.id2}-${grouper.id3}-grouper-indicators-presentation-panel`}
									filters={{
										...filters,
										presentationGroup: selectedPresentationGroup?.id ? selectedPresentationGroup.id.toString() : "",
										map: "",
										perspective: "",
										objective: "",
										situation: "",
										indicatorsId: "",
										budgetPlan: "",
										currentPeriod: ""
									}}
									grouper={grouper}
									groupersSelect={groupersSelect}
									configs={configs}
									configShowGoals={configShowGoals}
									refModalValuesOfPeriodIndicators={refModalValuesOfPeriodIndicators}
									printRef={printRef}
								/>
							))}
						</>
					)}
				</>
			)}
		</>
	), [loading, errorLoadingGroupers, groupers, configs, configShowGoals]);

	useEffectSkipInitialRender(() => {
		if(!selectedPresentationGroup)
			return;
		loadGroupers();
	}, [selectedPresentationGroup, groupersSelect, filters]);
    
	if(selectedPresentationGroup === undefined)
		return <RCCAlert 
			title={translate("Atenção")}
			description={translate("Selecione um grupo de apresentação ao lado")}
		/>;

	
	return (
		<RCCGrid container item direction="column" styleInline=" @media(max-width: 1560px){ max-width: calc(100% - 2rem); } @media(max-width: 600px){ max-width: 100%; }">

			{/* Header -> Results + Buttons */}
			<PageTitle
				title={selectedPresentationGroup?.title || ""}
			>
				<RCCTooltip
					color="grey"
					text={print ? translate("Imprimindo") : translate("Imprimir")}
					position="left"
				>
					<RCCButton 
						color="grey"
						layout="isRounded"
						size="md"
						icon={{
							name: "print"
						}}
						disabled={print}
						onClick={() => executePrint()}
					/>
				</RCCTooltip>
				<RCCTooltip
					text={`${translate("Configurações")} ${translate("gráficos")}`}
					color={showConfigs 
						|| configs.showAll 
						|| configShowGoals?.showGoalCommitmentInGraphic !== undefined
						|| configShowGoals?.showGoalCompetitivenessInGraphic !== undefined
						|| configShowGoals?.showGoalImprovementInGraphic !== undefined ? "blue" : "grey"}
				>
					<RCCButton
						icon={{name: "settings", color: "#FFF", size: 16}}
						color={showConfigs 
							|| configs.showAll 
							|| configShowGoals?.showGoalCommitmentInGraphic !== undefined
							|| configShowGoals?.showGoalCompetitivenessInGraphic !== undefined
							|| configShowGoals?.showGoalImprovementInGraphic !== undefined ? "blue" : "grey"}
						layout="isRounded"
						size="md"
						onClick={() => setShowConfigs((prevState) => !prevState)}
					/>
				</RCCTooltip> 	
				<RCCTooltip
					text={`${translate("Filtros")} Tags`}
					color={showTagsFilters || filters.tags ? "blue" : "grey"}
				>
					<RCCButton
						icon={{name: "tags", color: "#FFF", size: 16}}
						color={showTagsFilters || filters.tags ? "blue" : "grey"}
						layout="isRounded"
						size="md"
						onClick={() => setShowTagsFilters((prevState) => !prevState)}
					/>
				</RCCTooltip> 
				<ButtonExpandGroupers />
				 <RCCTooltip
					text={translate("Filtros")}
					color={showFilters || 
							filters.endDate || 
							filters.f || 
							filters.responsible || 
							filters.sector ||  
							filters.startDate ||
							filters.classification
						 ? "blue" : "grey"}
				>
					<RCCButton
						icon={{name: "filter", color: "#FFF", size: 16}}
						color={showFilters ||
								filters.endDate || 
								filters.f || 
								filters.responsible || 
								filters.sector || 
								filters.startDate || 
								filters.classification
							 ? "blue" : "grey"}
						layout="isRounded"
						size="md"
						onClick={() => setShowFilters((prevState) => !prevState)}
					/>
				</RCCTooltip> 
			</PageTitle>

			{/* Filters */}
			<FiltersContainer
				showFilters={showFilters}
				onSubmitFilters={handleSubmitFilters(submitFilters)}
				resetFilters={() => resetFilters({ 
					f: "", 
					responsible: { value: "", label: ""},
					presentationGroup: { value: "", label: ""},
					sector: { value: "", label: ""},
					startDate: null,
					endDate: null,
					classification: { value: "", label: "" }
				})}
			>
				<RCCGrid
					container
					item
					spacing={1}
				>
					<RCCGrid
						container 
						item
						xs={12}
						sm={12}
						md={4}
						lg={4}
					>
						<DateTimePickerRange
							control={controlFilters}
							label={translate("Período")}
							labelSeparator={translate("até")}
							nameInit = "startDate"
							nameEnd = "endDate"
							defaultValueEnd={filters.endDate}
							defaultValueInit={filters.startDate}
							type="datePicker"
							setValue={setValueFilters}
						/>
					</RCCGrid>
					<RCCGrid
						container 
						item
						xs={12}
						sm={12}
						md={4}
						lg={4}
					>
						<LovUsers 
							control={controlFilters}
							name="responsible"
							label={translate("Responsável")}
							defaultValue={filters.responsible}
							disabled={myIndicators}
							isClearable
						/>
					</RCCGrid>
					<RCCGrid
						container 
						item
						xs={12}
						sm={12}
						md={4}
						lg={4}
					>
						<LovSectors 
							control={controlFilters}
							name="sector"
							label={translate("Setor")}
							defaultValue={filters.sector}
							isClearable
						/>
					</RCCGrid>
				</RCCGrid>

				<RCCGrid
					container
					item
					spacing={1}
				>
					
					<RCCGrid
						container 
						item
						xs={12}
						sm={12}
						md={4}
						lg={4}
					>
						<LovClassifications
							control={controlFilters}
							name="classification"
							label={translate("Classificação")}
							isClearable
						/> 
					</RCCGrid>

					<RCCGrid
						container 
						item
						xs={12}
						sm={12}
						md={4}
						lg={4}
					>
						<RCCInput
							name="f" 
							label={translate("Pesquisar")}
							register={registerFilters}
							defaultValue={filters.f}
						/>
					</RCCGrid>
				</RCCGrid>
          
			</FiltersContainer>
			
			{/* Filters Tags */}
			<FiltersTagsContainer 
				ref={filtersTagsRef}
				onSubmitFilters={submitFiltersTags}
				tagType={TagsTypes.INDICATORS}
				showFilters={showTagsFilters}
			/>

			{/* Filters Configs Chart */}
			<ConfigsContainer 
				showConfigs={showConfigs}
				onSubmitConfigs={handleSubmitConfigs(submitConfigs)}
				resetConfigs={resetConfigsFunction}
			>	
				<Title size="sm" color="purple" styleInline="margin-top: 1rem;">{translate("Mostrar")}/{translate("Esconder")}</Title>
				<RCCGrid
					container
					item
					spacing={1}
				>
					<RCCGrid
						container 
						item
						xs={12}
						sm={6}
						md={6}
						lg={4}
					>
						<RCCSelectOptionsCard 
							defaultValue="1"
							options={[{
								value: "1",
								label: translate("Conforme indicador")
							},{
								value: "2",
								label: translate("Esconder todos")
							},{
								value: "3",
								label: translate("Mostrar todos")
							}]}
							label={translate("Mostrar valor no gráfico")}
							ref={showValuesRef}
						/>
					</RCCGrid>

					<RCCGrid
						container 
						item
						xs={12}
						sm={6}
						md={6}
						lg={4}
					>
						<RCCSwitch
							name="toggleConfigShowGoals"
							label={`${translate("Alterar metas que aparecem no gráfico")}`}
							register={registerConfigs}
							checked={toggleConfigShowGoals}
							onChange={() => setToogleConfigShowGoals((prevState) => !prevState)}
						/>							
					</RCCGrid>

				</RCCGrid>
				<RCCGrid container item>
					{toggleConfigShowGoals && (
						<FadedDiv styleInline=">label { flex-direction: row; } @media(min-width: 600px){ flex-direction: row; }">
							<RCCSwitch
								name="showGoalImprovementInGraphic"
								label={`${translate("Mostrar meta melhoria")}`}
								register={registerConfigs}
								defaultChecked
							/>
							<RCCSwitch
								name="showGoalCompetitivenessInGraphic"
								label={`${translate("Mostrar meta competitividade")}`}
								register={registerConfigs}
							/>
							<RCCSwitch
								name="showGoalCommitmentInGraphic"
								label={`${translate("Mostrar meta compromisso")}`}
								register={registerConfigs}
							/>
						</FadedDiv>
					)}
				</RCCGrid>
			</ConfigsContainer>

			{/* Groupers Select -> Origin -> Delayed */}
			<form onSubmit={handleSubmitGroupers(submitGroupers)} style={{marginBottom: "1rem"}}>
				<RCCGrid
					container
					item
					spacing={1}
				>
					<RCCGrid
						container
						item
						xs={12}
						sm={6}
						md={4}
						lg={3}
						alignItems="baseline"
					>
						<Select 
							control={controlGroupers}
							name="group"
							label={translate("Agrupadores")}
							options={optionsGroupers}
							value={optValueGroup}
							defaultValue={groupersSelect.group}
							onChangeCapture={() => buttonSubmitFormGroupersRef.current?.click()}
						/>
					</RCCGrid>
						
					<RCCGrid
						container
						item
						xs={12}
						sm={4}
						md={3}
						lg={2}
						alignItems="center"
					>
						<DateTimePicker
							type="datePicker" 
							control={controlGroupers}
							name="baseYear"
							label={translate("Ano base")}
							defaultValue={new Date(Number(groupersSelect.baseYear), 0, 1)}
							onChange={(data) => {
								if(isValidDate(data))
									buttonSubmitFormGroupersRef.current?.click();
							}}
							props={{
								datePicker: {
									format: "yyyy",
									views: ["year"]
								}
							}}
						/>			
					</RCCGrid>

					

					<RCCGrid
						container
						item
						xs={12}
						sm={12}
						md={5}
						lg={7}
						justifyContent="flex-end"
					>
						<RCCSelectOptionsCard 
							defaultValue={myIndicators ? "S" : "N"}
							options={[{
								value: "N",
								label: translate("Todos indicadores")
							},{
								value: "S",
								label: translate("Meus indicadores")
							}]}
							label="&nbsp;"
							onChange={(e) => {
								setValueFilters("responsible", { value: "", label: ""});
								if(e === "S"){
									setMyIndicators(true);
									setFilters({
										...filters,
										responsible: user.efa005Id.toString()
									});
									return;
								}
								setMyIndicators(false);
								setFilters({
									...filters,
									responsible: ""
								});
							}}
						/>
					</RCCGrid>

				</RCCGrid>
				<button 
					aria-label="Submit Form"
					ref={buttonSubmitFormGroupersRef}
					type="submit" 
					style={{ display: "none" }}
				></button>
			</form>				

			{Groupers}
            
		</RCCGrid>
	);
};

export default PresentationGroupContentComponent;
